import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

import MasterCardLogo from '../../assets/master-logo.png';
import PayPalLogo from '../../assets/paypal-by-epoch-1.png';
import VisaLogo from '../../assets/visa-logo.png';
import CalendarCheckoutStore from '../../store/CalendarCheckoutStore';

import { getCalendarProducts } from './services';


function CalendarProducts(props) {
  const { setSecondStep, selectedProduct, setSelectedProduct, selectedPaymentMethod, setSelectedPaymentMethod } = props;
  const [products, setProducts] = useState([]);
  const paysafeAvailable =
    selectedProduct &&
    selectedProduct.categories.find((category) => category.type === 'CC');
  const epochAvailable =
    selectedProduct &&
    selectedProduct.categories.find((category) => category.type === 'EW');
  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async() => {
    const { error, data } = await getCalendarProducts();
    if (!error && data.data.status === 'SUCCESS') {
      setSelectedProduct(data.data.products[0]);
      setSelectedPaymentMethod(data.data.products[0].categories[0].type);
      setProducts(data.data.products);
    }
    console.log('[TODO] - add error handling for getCalendarProducts error or no products found');
  };

  const handleChange = (e) => {
    const { value } = e.target;
    const prod = products.find((el) => el.id === parseInt(value, 10));
    setSelectedProduct(prod);
  };

  const handlePaymentMethod = (e) => {
    setSelectedPaymentMethod(e.target.value);
  };

  const handleProductSubmit = () => {
    console.log(selectedPaymentMethod, selectedProduct);
    CalendarCheckoutStore.setProduct({
      paymentMethod: selectedPaymentMethod,
      product: selectedProduct,
    });
    setSecondStep(true);
  };

  return (
    <div className="calendar-products">
      {products.length > 0 && (
        <>
          <h4>
            The only calendar where you won't want to turn the page when the month ends... a sexy anchor for each month of the year.
          </h4>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="gender"
              name="gender1"
              value={selectedProduct.id}
              onChange={handleChange}
            >
              {products.map((el) => (
                <FormControlLabel
                  key={el.id}
                  className={`form-control ${
                    el.id === selectedProduct.id ? 'form-control-active' : ''
                  }`}
                  control={<Radio />}
                  label={
                    <div className="product-label">
                      <div className="calendar-dimensions">
                        <span className="calendar-dimensions-name">{el.details.calendarType}</span>
                        <span className="calendar-dimensions-sub">{el.details.width}x{el.details.length} inches</span>
                      </div>
                      <span>{el.currency.symbol}{el.amount}</span>
                    </div>
                  }
                  value={el.id}
                />
              ))}
            </RadioGroup>
          </FormControl>
          <p className="calendar-disclaimer">* Depending on your location handling and shipping fees may apply.</p>
          <h3>CHOOSE PAYMENT METHOD</h3>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="gender"
              name="gender1"
              value={selectedPaymentMethod}
              onChange={handlePaymentMethod}
            >
              {epochAvailable && (
                <FormControlLabel
                  className="form-control"
                  control={<Radio />}
                  label={
                    <div className="product-label">
                      <span>PayPal</span>
                      <span>
                        <img alt="visa" src={VisaLogo} />
                        <img alt="paypal" src={PayPalLogo} />
                      </span>
                    </div>
                  }
                  value="EW"
                />
              )}
              {paysafeAvailable && (
                <FormControlLabel
                  className="form-control"
                  control={<Radio />}
                  label={
                    <div className="product-label">
                      <span className="payment-label">Credit Card</span>
                      <span>
                        <img alt="visa" src={VisaLogo} />
                        <img alt="mastercard" src={MasterCardLogo} />
                      </span>
                    </div>
                  }
                  value="CC"
                />
              )}
            </RadioGroup>
          </FormControl>
          <button className="btn btn-red btn-calendar" onClick={handleProductSubmit}>
            Continue
          </button>
        </>
      )}
    </div>
  );
}

export default observer(CalendarProducts);
